import React from 'react';
import cn from 'classnames';
import Feedbacks from './Feedbacks';
import Awards from '@/Framework/UI/Pages/Landing/Sections/Awards';
import Customers from './Customers';
import ContactUs from './ContactUs';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import panelStyles from '../Panel/panel.scss';
import aboutUsStyles from './aboutUs.scss';

const AboutUs = () => (
  <div className={ cn(alignStyles.alignCenter, aboutUsStyles.introduction) }>
    <Customers />
    <Feedbacks />
    <Awards
      className={ aboutUsStyles.awardsContainer }
      titleClassName={ panelStyles.header }
      descriptionClassName={ panelStyles.subTitle }
      cardsClassName={ aboutUsStyles.awardsHolder }
    />
    <ContactUs />
  </div>
);

export default AboutUs;
